import { modalRenderer } from '~/modal/modalRendererRegistry';
import { EditLayeredMapModalContainer } from './editLayeredMapModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    EditLayeredMap: undefined;
  }
}
modalRenderer.register('EditLayeredMap', EditLayeredMapModalContainer);
